import logotypWhite from '../../assets/logotyp_white.png';
import { Box, Container, Flex, Image, Link, Separator, SimpleGrid, Spacer, Stack, Text, VStack } from '@chakra-ui/react';
import { FiFacebook, FiInstagram, FiMail, FiPhone } from 'react-icons/fi';
import { Link as RouterLink } from 'react-router-dom';

const footerLinks = [
    { label: 'O nas', href: '#o_nas' },
    { label: 'Korepetycje', href: '#korepetycje' },
    { label: 'Kursy', href: '#kursy' },
    { label: 'Cennik', href: '#cennik' },
    { label: 'FAQ', href: '#faq' },
    { label: 'Placówki', href: '#placowki' },
    { label: 'Kontakt', href: '#kontakt' },
];

const legalLinks = [
    { label: "Polityka prywatności", href: "/polityka-prywatnosci" },
    { label: "Ochrona małoletnich", href: "/ochrona-maloletnich" },
];

export default function HomeFooter() {
    return (
        <Box as="footer" bg="brand.100" borderTop="1px solid" borderColor="orange.100" py={{ base: 6, md: 8 }}>
            <Container maxW="container.xl">
                <SimpleGrid columns={{ base: 1, md: 3 }} gap={{ base: 8, md: 10 }}>
                    <VStack align="start" gap={4}>
                        <Stack direction="row" align="center" gap={3}>
                            <Box>
                                <Image
                                    src={logotypWhite}
                                    alt="Opanuj.to"
                                    maxW="150px"
                                    maxH="50px"
                                    mb={2}
                                    objectFit="contain"
                                />
                                <Text color="white" fontWeight="semibold" fontSize='md' textTransform="uppercase" letterSpacing="wider" mb={1}>
                                    Dane do przelewu
                                </Text>
                                <Text fontWeight={100} color="rgba(255, 255, 255, 0.7)">
                                    EDULOGIC Dominik Soszyński<br />
                                    ul. Gwiaździsta 33/19, 01-651 Warszawa
                                </Text>
                                <Text fontWeight="semibold" color="white" mb={1}>
                                    Numer konta: 97 1050 1054 1000 0090 8190 5367
                                </Text>
                            </Box>
                        </Stack>
                    </VStack>

                    <VStack align={{ base: "start", md: "start" }} gap={3}>
                        <Text color="white" fontWeight="semibold" fontSize='sm' textTransform="uppercase" letterSpacing="wider">
                            Linki
                        </Text>
                        <Stack gap={2}>
                            {footerLinks.map((link) => (
                                <Link key={link.label} href={link.href} color="rgba(255, 255, 255, 0.7)" _hover={{ color: "brand.900" }}>
                                    {link.label}
                                </Link>
                            ))}
                        </Stack>
                    </VStack>

                    <VStack align={{ base: "start", md: "start" }} gap={3}>
                        <Text color="white" fontWeight="semibold" fontSize='sm' textTransform="uppercase" letterSpacing="wider">
                            Informacje prawne
                        </Text>
                        <Stack gap={2}>
                            {legalLinks.map((link) => (
                                <Link key={link.label} as={RouterLink} to={link.href} color="rgba(255, 255, 255, 0.7)" _hover={{ color: "brand.900" }}>
                                    {link.label}
                                </Link>
                            ))}
                        </Stack>

                    </VStack>
                </SimpleGrid>

                <Separator my={8} borderColor="gray.200" />

                <Flex alignItems="center" gap={3} mr={2}>
                    <Box>
                        <Text color="white" fontSize="sm">
                            © 2026 Opanuj.to
                        </Text>
                        <Text color="white" fontSize="sm">
                            Wszelkie prawa zastrzeżone
                    </Text>
                    </Box>
                    <Spacer />
                    <Link href="tel:+48513018199" color="white" display="inline-flex" alignItems="center" _hover={{ color: 'orange.600', textDecoration: 'none' }}>
                        <FiPhone />
                    </Link>
                    <Link href="mailto:sekretariat@opanuj.to" color="white" display="inline-flex" alignItems="center" _hover={{ color: 'orange.600', textDecoration: 'none' }}>
                        <FiMail />
                    </Link>
                    <Link href="http://www.facebook.com/Opanuj.To" target="_blank" rel="noreferrer" color="white" display="inline-flex" alignItems="center" _hover={{ color: 'orange.600', textDecoration: 'none' }}>
                        <FiFacebook />
                    </Link>
                    <Link href="https://www.instagram.com/opanuj.to/" target="_blank" rel="noreferrer" color="white" display="inline-flex" alignItems="center" _hover={{ color: 'orange.600', textDecoration: 'none' }}>
                        <FiInstagram />
                    </Link>
                </Flex>
            </Container>
        </Box>
    );
}
